import React, { Component, PropTypes } from "react";
import { withRouter, Link } from "react-router/es";
import { routeCodes, subRouteCodes } from "constants/routes";
import DropdownMenu from "components/UI/DropdownMenu";
import { userPrivileges } from "constants/user";
import { SELECTIVE_TRANSFER_PAGE } from "constants/assetTransfer";
import DateUtilities from "records/DateUtilities";
import {
  displayDateFormat,
  inputDateFormatTS,
} from "../../constants/globalPrice";
import { ingredientTypeMap } from "constants/ingredientType";
import ReactTooltip from "react-tooltip";
import Avatar from "assets/img/avatar.svg";

import moment from "moment";
import { setNotificationCenterModalState } from "actions/notifications";
import { setGlobalPriceUpdateModalState } from "actions/globalPrice";

import { getSyscoProducts } from "actions/syscoProducts";
import {
  getPriceEffectiveDate,
  shouldFetchSyscoProducts,
} from "helpers/globalPriceHelper";

const apiUrl = APP_CONFIG.api.url;
const HELP_LINK = "https://intercom.help/syscostudio/en/";


const formatFirstName = (name) => {
  if (name && name.includes(".")) {
    const firstName = name.split(".");
    const formattedName = firstName[0].toLowerCase();
    return formattedName.charAt(0).toUpperCase() + formattedName.slice(1);
  } else {
    return name;
  }
};
const formatFullName = (name) => {
  if (name && name.includes(".")) {
    const nameArr = name.toLowerCase().split(".");
    return (
        nameArr[0].charAt(0).toUpperCase() +
        nameArr[0].slice(1) +
        " " +
        nameArr[1].charAt(0).toUpperCase() +
        nameArr[1].slice(1)
    );
  } else {
    return name;
  }
};


const ButtonDefault = (name) => {
  return (
    <div className="section-bg-layer user-info-wrapper flex align-item-center ml-12">
      <div className={"user-identity"}>
        <div className={"user-identity-name"}>Hi, {formatFirstName(name)}</div>
      </div>
      <span className="arrow" />
    </div>
  );
};

class UserMenu extends Component {
  static propTypes = {
    auth: PropTypes.object,
    user: PropTypes.object,
    location: PropTypes.object,
    menuPosition: PropTypes.string,
    registerWorkflowInProgress: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
    ]),
    menuRoutes: PropTypes.array,
    router: PropTypes.object,
    dispatch: PropTypes.func,
    currentBrand: PropTypes.object,
    setChangeAccVisibility: PropTypes.func,
    roleInfo: PropTypes.shape({
      changeAccAllowed: PropTypes.bool,
    }),
    currentPage: PropTypes.number,
    notifications: PropTypes.object,
    syscoProducts: PropTypes.object,
    syscoProductsLoading: PropTypes.bool,
  };

  componentDidMount() {
    const { dispatch, auth, user, currentBrand, syscoProducts } = this.props;
    const authenticated = auth.get("authenticated");
    if (!authenticated) return;

    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);
    if (!!priceEffectiveDate && shouldFetchSyscoProducts(user, syscoProducts)) {
      dispatch(
        getSyscoProducts(
          currentBrand.get("id"),
          ingredientTypeMap.SYSCO_PRODUCTS
        )
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { auth: prevAuth, currentBrand: prevBrand } = prevProps;
    const {
      dispatch,
      auth,
      user,
      currentBrand,
      syscoProducts,
      syscoProductsLoading,
    } = this.props;
    const prevAuthenticated = prevAuth.get("authenticated");
    const authenticated = auth.get("authenticated");
    if (
      !syscoProductsLoading &&
      ((!prevAuthenticated && authenticated) ||
        (prevBrand && currentBrand.get("id") !== prevBrand.get("id")))
    ) {
      const priceEffectiveDate = getPriceEffectiveDate(currentBrand);
      if (
        !!priceEffectiveDate &&
        shouldFetchSyscoProducts(user, syscoProducts)
      ) {
        dispatch(
          getSyscoProducts(
            currentBrand.get("id"),
            ingredientTypeMap.SYSCO_PRODUCTS
          )
        );
      }
    }
  }

  setNotificationCenterVisibility = (isOpen) => {
    const { dispatch } = this.props;
    dispatch(setNotificationCenterModalState(isOpen));
  };

  setGlobalPriceUpdateModalVisibility = (isPriceOutdated) => {
    const { dispatch, user } = this.props;

    if (isPriceOutdated || user.get("internal")) {
      dispatch(setGlobalPriceUpdateModalState(true));
    }
  };

  renderAuthenticated() {
    const {
      user,
      menuPosition,
      registerWorkflowInProgress,
      currentBrand,
      setChangeAccVisibility,
      roleInfo,
      currentPage,
      notifications: { data },
    } = this.props;

    const priceEffectiveDate = getPriceEffectiveDate(currentBrand);
    const currentDate = moment().startOf("day");
    const priceEffDate = moment(
      DateUtilities.convertTimeFormatLocal(
        priceEffectiveDate,
        inputDateFormatTS,
        displayDateFormat
      )
    );
    const isPriceOutdated = priceEffDate.isBefore(currentDate);

    let { menuRoutes } = this.props;
    const privileges = user.get("privileges");
    const isAssetTransferAllowed = privileges.includes(
      userPrivileges.ASSET_TRANSFER
    );

    if (!menuRoutes) menuRoutes = [];

    const routeElements = [];
    const isAuthorizedToDirectVerify = privileges.includes(
      userPrivileges.GBP_DIRECT_VERIFICATION
    );

    menuRoutes.forEach((route, index) => {
      if (!registerWorkflowInProgress) {
        routeElements.push(
          <Link key={index} to={route.path}>
            {route.name}
          </Link>
        );
      }
    });

    if (!isAssetTransferAllowed) {
      routeElements.pop(
        (item) => item.props.to === "/manage-account/asset-transfer"
      );
    }

    if (
      roleInfo.changeAccAllowed &&
      currentPage !== SELECTIVE_TRANSFER_PAGE.SELECT_ACCOUNTS
    ) {
      routeElements.push(
        <Link
          key={menuRoutes.length}
          onClick={() => setChangeAccVisibility(true)}
          className="pointer"
        >
          Change Account
        </Link>
      );
    }

    routeElements.push(
      <a key="logout" href={`${apiUrl}/oauth2/logout`}>
        Logout
      </a>
    );

    const position = menuPosition || "right";
    const content = currentBrand.get("brandName");

    return (
      <div className="flex align-item-center justify-end">
        <div className={"flex items-center"}>
          {!!priceEffectiveDate ? (
            isPriceOutdated ? (
              <div
                className={"section-bg-layer datepicker-widget outdated"}
                data-tip
                data-for="outdated-price-eff-date"
                onClick={() =>
                  this.setGlobalPriceUpdateModalVisibility(isPriceOutdated)
                }
              >
                <div className={"datepicker-icon"}></div>
                <div className={"datepicker-content flex-col"}>
                  <div className={"datepicker-title"}>Costs last updated</div>
                  <div className={"datepicker-value"}>
                    {DateUtilities.convertTimeFormatLocal(
                      priceEffectiveDate,
                      inputDateFormatTS,
                      displayDateFormat
                    )}
                  </div>
                </div>
                <ReactTooltip
                  type="warning"
                  place={"bottom"}
                  effect={"solid"}
                  className={"outdated-price-tooltip"}
                  id="outdated-price-eff-date"
                >
                  Your Prices Are Outdated
                </ReactTooltip>
              </div>
            ) : (
              <div
                className={"section-bg-layer datepicker-widget"}
                onClick={() =>
                  this.setGlobalPriceUpdateModalVisibility(isPriceOutdated)
                }
              >
                <div className={"datepicker-icon"}></div>
                <div className={"datepicker-content flex-col"}>
                  <div className={"datepicker-title"}>Costs last updated</div>
                  <div className={"datepicker-value"}>
                    {DateUtilities.convertTimeFormatLocal(
                      priceEffectiveDate,
                      inputDateFormatTS,
                      displayDateFormat
                    )}
                  </div>
                </div>
              </div>
            )
          ) : null}
          {!registerWorkflowInProgress && (
            <div
              className={
                "action-item border-rounded section-bg-layer pointer ml-12"
              }
            >
              <div
                className={`notification-icon ${
                  data.length !== 0 ? "with-new" : ""
                }`}
                onClick={() => {
                  this.setNotificationCenterVisibility(true);
                }}
              ></div>
            </div>
          )}

          <Link
            className={
              "action-item border-rounded section-bg-layer pointer ml-12"
            }
            to={HELP_LINK}
            target="_blank"
          >
            <div className={"help-icon"}></div>
          </Link>
        </div>

        <DropdownMenu
          buttonComponent={ButtonDefault(user.getFirstName())}
          menuPosition={position}
        >
          <a>
            <div className="user-info-summary">
              <div className="user-info-avatar">
                <img src={Avatar} alt="user image" />
              </div>
              <div className="user-info-detail">
                <div className="user-info-name">
                  {formatFullName(user.getFullName())}
                </div>
                <div className="user-info-location">{content}</div>
              </div>
            </div>
          </a>
          {routeElements}
        </DropdownMenu>
      </div>
    );
  }

  renderDefault() {
    const { pathname } = this.props.location;
    if (pathname === routeCodes.LOGIN) {
      return <Link to={routeCodes.REGISTER}>Register</Link>;
    }

    if (pathname.includes(routeCodes.RESET_PASSWORD)) {
      return <Link to={routeCodes.LOGIN}>Log In</Link>;
    }
    return null;
  }

  render() {
    const { auth } = this.props;
    const authenticated =
      auth.get("authenticated") || auth.get("adminAuthenticated");
    return (
      <div className="user-menu">
        {authenticated ? this.renderAuthenticated() : this.renderDefault()}
      </div>
    );
  }
}
export default withRouter(UserMenu);